import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const ServiceCategorySelector = ({ 
  selectedCategory, 
  onCategoryChange, 
  error,
  className = '' 
}) => {
  const serviceCategories = [
    { 
      value: 'internet', 
      label: 'Internet Providers',
      description: 'ISPs, broadband, fiber, cable internet'
    },
    { 
      value: 'mobile', 
      label: 'Mobile Carriers',
      description: 'Cell service, data, SMS, voice calls'
    },
    { 
      value: 'streaming', 
      label: 'Streaming Services',
      description: 'Netflix, YouTube, Spotify, video platforms'
    },
    { 
      value: 'cloud', 
      label: 'Cloud Services',
      description: 'AWS, Google Cloud, Azure, hosting'
    },
    { 
      value: 'financial', 
      label: 'Financial Services',
      description: 'Banking, payment apps, trading platforms'
    },
    { 
      value: 'gaming', 
      label: 'Gaming Platforms',
      description: 'Steam, PlayStation, Xbox, online games'
    }
  ];

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="flex items-center space-x-2">
        <Icon name="Layers" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">Service Category</h3>
      </div>
      
      <Select
        label="Select Service Type"
        description="Choose the category that best describes the affected service"
        placeholder="Choose a service category..."
        options={serviceCategories}
        value={selectedCategory}
        onChange={onCategoryChange}
        error={error}
        required
        searchable
        className="w-full"
      />
    </div>
  );
};

export default ServiceCategorySelector;